export default __webpack_public_path__ + "static/media/folder-minus.aa11a1ba.svg";